import BuilderSDK from '@builder.io/sdk';

import { BuilderConfig } from '../../types/Builder';
import BusinessHubHeroTraining, { BusinessHubHeroTrainingProps } from './business-hub-hero-training';

export const BusinessHubHeroTrainingBuilderConfig: BuilderSDK.Component = {
    name: 'Business Hub Hero Training',
    inputs: [
        {
            name: 'title',
            type: 'richText',
            defaultValue: '',
        },
        {
            name: 'description',
            type: 'richText',
            defaultValue: '',
        },
        {
            name: 'ctaText',
            type: 'text',
            defaultValue: '',
        },
        {
            name: 'ctaLink',
            type: 'url',
            defaultValue: '',
        },
        {
            name: 'background',
            type: 'object',
            subFields: [
                {
                    name: 'backgroundRightImage',
                    type: 'object',
                    subFields: [
                        { name: 'desktop', type: 'file' },
                        { name: 'mobile', type: 'file' },
                    ],
                },
                {
                    name: 'backgroundImage',
                    type: 'object',
                    subFields: [
                        { name: 'desktop', type: 'file' },
                        { name: 'mobile', type: 'file' },
                    ],
                },
                {
                    name: 'backgroundColor',
                    type: 'color',
                },
                {
                    name: 'textColor',
                    type: 'color',
                },
            ],
        },
    ],
};

const builderConfig: BuilderConfig<BusinessHubHeroTrainingProps> = {
    component: BusinessHubHeroTraining,
    config: BusinessHubHeroTrainingBuilderConfig,
};

export default builderConfig;
